/* Tyres Direct V2 product page behaviour (sections/tdx-product.liquid). Ported from the approved mockup
   docs/v2/design-round-20261014/b/product.html (Adil, 15 Oct 2026) and the kept behaviour of assets/td-product.js.
   - gallery: swipeable track, arrows, thumbnails, counter; full-bleed photos (close-ups) found by their edges
   - full-screen photo viewer: keys, focus trap, swipe, click or double-tap zoom
   - fit check against the remembered size (TDFit): match, another size, or the compact size and reg entry
   - quantity: 1 / 2 / 4 presets and two steppers (card and sticky bar) kept in step, capped at stock, subtotal
   - Add to basket: the real form (POST /cart/add) handed to TDB.add (tdx-chrome.js runs the add moment)
   - sticky buy bar (TD.observeBuybar), never over the footer
   - "Also in <size>": sections/tdx-alt fetched with the Section Rendering API (in-stock summary and candidates)
   - the real EU label from EPREL, with the designed "not published yet" state when EPREL does not serve it
   Needs tdx.js (window.TDX); uses td-v2.js (TD, TDFit) and tdx-chrome.js (TDB) when present. Never throws. */
(function () {
  const start = () => {
    const root = document.getElementById('pdp');
    const X = window.TDX;
    if (!root || !X || root.dataset.ready) return;
    root.dataset.ready = '1';
    const $ = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => [...r.querySelectorAll(s)];
    const ic = X.ic;
    const D = root.dataset;
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const track = (n, d) => { try { if (window.TD && TD.track) TD.track(n, d); } catch (e) { /* never throw */ } };
    const later = (fn, ms) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: ms }) : setTimeout(fn, Math.min(ms, 600)));
    const BUY = D.buy === '1';
    const PRICE = +D.price || 0; /* pence */
    const SIZE = D.size || '';
    const NAME = D.name || '';
    const mine = { w: D.w, a: D.a, r: D.r };
    const pounds = p => X.gbp(p / 100);
    let barCheck = () => {}; /* set by the sticky bar below; the fit line and its entry change the card's position */

    /* Size links follow the shared contract (TDX.sizeUrl, which honours window.TD_SIZE_PAGES) */
    if (D.w && D.r) { const u = X.sizeUrl(D.w, D.a, D.r); $$('[data-size-link]', root).forEach(a => { a.href = u; }); }

    /* ================= Gallery ================= */
    const trk = $('#track'), stage = $('#stage');
    const slides = trk ? $$('.slide', trk) : [];
    const N = slides.length;
    let gi = 0;
    const mark = i => { gi = i; const gn = $('#gn'); if (gn) gn.textContent = i + 1; $$('#thumbs button').forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false')); };
    const go = (i, instant) => { if (!N) return; i = (i + N) % N; trk.scrollTo({ left: i * trk.clientWidth, behavior: reduce() || instant ? 'auto' : 'smooth' }); mark(i); };
    if (N) trk.addEventListener('scroll', () => { const i = Math.round(trk.scrollLeft / Math.max(1, trk.clientWidth)); if (i !== gi && i < N) mark(i); }, { passive: true });
    root.addEventListener('click', e => {
      const t = e.target.closest('#thumbs [data-t]'); if (t) go(+t.dataset.t);
      const g = e.target.closest('#stage [data-g]'); if (g) go(gi + +g.dataset.g);
    });

    /* Full-bleed photos (P33): a close-up fills its frame, so most of its edge is not white. Checked on a tiny
       same-origin rendition; such photos fill the stage, and the first one becomes the features card photo. */
    const small = (u, w) => u.replace(/([?&])width=\d+/, `$1width=${w}`);
    const bleedOf = img => {
      try {
        const c = document.createElement('canvas'); c.width = c.height = 40;
        const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, 40, 40);
        const d = x.getImageData(0, 0, 40, 40).data; let n = 0, t = 0;
        for (let k = 0; k < 40; k++) [[k, 0], [k, 39], [0, k], [39, k]].forEach(([px, py]) => { const o = (py * 40 + px) * 4; t++; if (Math.min(d[o], d[o + 1], d[o + 2]) < 235) n++; });
        return n / t > 0.25;
      } catch (e) { return false; }
    };
    const bleeds = [];
    let fphAt = Infinity;
    const setBleed = i => {
      bleeds.push(i);
      slides[i].classList.add('bleed');
      const tb = $$('#thumbs button')[i]; if (tb) tb.classList.add('bleed');
      const vs = document.querySelectorAll('#pvs .pv-sl')[i]; if (vs) vs.classList.add('bleed');
      const fph = $('#fph'), im = fph && $('img', fph);
      if (im && i < fphAt) { fphAt = i; im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = small(slides[i].dataset.full, 900); fph.classList.remove('st'); }
    };
    if (N) later(() => slides.forEach((s, i) => {
      if (!s.dataset.full) return;
      const p = new Image(); p.onload = () => { if (bleedOf(p)) setBleed(i); }; p.src = small(s.dataset.full, 60);
    }), 1500);

    /* ================= Full-screen photo viewer (P4) ================= */
    const V = (() => {
      if (!N) return null;
      const PH = slides.map((s, i) => ({ src: s.dataset.full, alt: s.dataset.alt || NAME, lab: `photo ${i + 1}` }));
      const el = document.createElement('div');
      el.className = N > 1 ? 'pv' : 'pv one'; el.id = 'pv'; el.hidden = true;
      el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'pv-t');
      el.innerHTML = `
        <div class="pv-top">
          ${N > 1 ? `<span class="pv-ct sk" aria-hidden="true"><b id="pvn">1</b><small>/ ${N}</small></span>` : ''}
          <p class="pv-t" id="pv-t"><span class="sr">Photos of the </span><b>${esc(NAME)}</b><span>${esc(D.sizeline)}</span></p>
          <button class="pv-x sk" type="button" aria-label="Close photos">${ic('x')}</button>
        </div>
        <p class="pv-hint" aria-hidden="true"><span class="hd">${N > 1 ? 'Click the photo to zoom, arrow keys for the next' : 'Click the photo to zoom'}</span><span class="ht">${N > 1 ? 'Swipe for the next photo, double-tap to zoom' : 'Double-tap the photo to zoom'}</span></p>
        <div class="pv-main"><div class="pv-st" id="pvst"><div class="pv-strip" id="pvs">${PH.map((g, i) => `<div class="pv-sl${bleeds.includes(i) ? ' bleed' : ''}" role="group" aria-roledescription="slide" aria-label="Photo ${i + 1} of ${N}"><img src="${esc(g.src)}" alt="${esc(g.alt)}" width="1400" height="1400" draggable="false" loading="lazy"></div>`).join('')}</div></div></div>
        ${N > 1 ? `<button class="pv-nv p sk" type="button" aria-label="Previous photo" data-pvg="-1">${ic('chevron-left')}</button>
        <button class="pv-nv n sk" type="button" aria-label="Next photo" data-pvg="1">${ic('chevron-right')}</button>
        <div class="pv-th" role="group" aria-label="Choose a photo">${PH.map((g, i) => `<button type="button" class="${bleeds.includes(i) ? 'bleed' : ''}" data-pv="${i}" aria-label="Photo ${i + 1} of ${N}" aria-current="${i === 0}"><img src="${esc(small(g.src, 160))}" alt="" width="76" height="76" loading="lazy"></button>`).join('')}</div>` : ''}
        <p class="sr" aria-live="polite" id="pvlive"></p>`;
      document.body.appendChild(el);
      const st = $('#pvst'), strip = $('#pvs');
      let vi = 0, zoomed = null, opener = null;
      const imgAt = i => strip.children[i].querySelector('img');
      const unzoom = () => { if (zoomed) { zoomed.classList.remove('z'); zoomed = null; st.classList.remove('zoomed'); } };
      const show = (i, quiet) => {
        unzoom(); vi = (i + N) % N;
        strip.style.transform = `translateX(${-vi * 100}%)`;
        [...strip.children].forEach((s, k) => { s.setAttribute('aria-hidden', k === vi ? 'false' : 'true'); if (Math.abs(k - vi) <= 1) { const im = s.querySelector('img'); if (im) im.loading = 'eager'; } });
        if (N > 1) { $('#pvn').textContent = vi + 1; $$('.pv-th button', el).forEach((b, k) => b.setAttribute('aria-current', k === vi ? 'true' : 'false')); }
        if (!quiet) $('#pvlive').textContent = `Photo ${vi + 1} of ${N}`;
      };
      const setInert = on => [...document.body.children].forEach(c => { if (c !== el && c.tagName !== 'SCRIPT') { if (on) c.setAttribute('inert', ''); else c.removeAttribute('inert'); } });
      const lock = on => { if (window.TD && TD.lockScroll) TD.lockScroll(on); document.documentElement.style.overflow = on ? 'hidden' : ''; };
      const open = (i, from) => {
        opener = from || document.activeElement;
        strip.style.transition = 'none'; show(i, true); void strip.offsetWidth; strip.style.transition = '';
        el.hidden = false; setInert(true); lock(true);
        setTimeout(() => el.querySelector('.pv-x').focus(), 30);
      };
      const close = () => {
        if (el.hidden) return;
        unzoom(); el.hidden = true; setInert(false); lock(false);
        go(vi, true); /* the page gallery follows the photo last seen */
        if (opener && opener.focus) opener.focus(); opener = null;
      };
      el.addEventListener('click', e => {
        if (e.target.closest('.pv-x')) close();
        const g = e.target.closest('[data-pvg]'); if (g) show(vi + +g.dataset.pvg);
        const t = e.target.closest('[data-pv]'); if (t) show(+t.dataset.pv);
      });
      /* keys: Escape closes, arrows step, Tab stays inside (focus trapped and returned) */
      document.addEventListener('keydown', e => {
        if (el.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
        const inTh = e.target.closest && e.target.closest('.pv-th');
        if (N > 1 && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
          e.preventDefault();
          if (inTh) { const b = $$('.pv-th button', el); const k = (b.indexOf(e.target.closest('button')) + (e.key === 'ArrowRight' ? 1 : -1) + N) % N; b[k].focus(); show(k); }
          else show(vi + (e.key === 'ArrowRight' ? 1 : -1));
          return;
        }
        if (e.key !== 'Tab') return;
        const f = [...el.querySelectorAll('button')].filter(b => b.offsetParent !== null);
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (!el.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      }, true);
      /* pointer: swipe (or drag) to step; click with a mouse, or double-tap, to zoom; zoomed, the photo follows */
      let down = null, dx = 0, lastTap = 0;
      const origin = e => { const r = st.getBoundingClientRect(); return `${Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)).toFixed(1)}% ${Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100)).toFixed(1)}%`; };
      const toggleZoom = e => { if (zoomed) { unzoom(); return; } zoomed = imgAt(vi); zoomed.style.transformOrigin = origin(e); zoomed.classList.add('z'); st.classList.add('zoomed'); };
      st.addEventListener('pointerdown', e => { if (e.button) return; down = { x: e.clientX, y: e.clientY, t: e.pointerType }; dx = 0; try { st.setPointerCapture(e.pointerId); } catch (x) { /* ok */ } if (!zoomed) strip.style.transition = 'none'; });
      st.addEventListener('pointermove', e => {
        if (zoomed) { if (e.pointerType === 'mouse' || down) zoomed.style.transformOrigin = origin(e); return; }
        if (!down || N < 2) return;
        dx = e.clientX - down.x; strip.style.transform = `translateX(calc(${-vi * 100}% + ${dx}px))`;
      });
      st.addEventListener('pointerup', e => {
        if (!down) return; const d = down; down = null; strip.style.transition = '';
        const moved = Math.hypot(e.clientX - d.x, e.clientY - d.y);
        if (!zoomed && N > 1 && Math.abs(dx) > Math.min(70, st.clientWidth * 0.15)) { show(vi + (dx < 0 ? 1 : -1)); return; }
        if (!zoomed) show(vi, true);
        if (moved > 8) return;
        if (d.t === 'mouse') toggleZoom(e);
        else { const now = performance.now(); if (now - lastTap < 320) { toggleZoom(e); lastTap = 0; } else lastTap = now; }
      });
      st.addEventListener('pointercancel', () => { down = null; strip.style.transition = ''; if (!zoomed) show(vi, true); });
      return { open, close };
    })();
    if (V) {
      const zm = $('#zm'); if (zm) zm.addEventListener('click', e => V.open(gi, e.currentTarget));
      trk.addEventListener('click', e => { if (e.target.closest('.slide')) V.open(gi, trk); });
    }

    /* ================= Fit check (P26, D6): match, another size, or no size ================= */
    const fitli = $('#fitli'), fitx = $('#fitx'), fxp = $('#fxp');
    const fxoHTML = fitli ? fitli.innerHTML : '';
    const F = () => (window.TDFit && TDFit.get ? TDFit : null);
    let lastFit = null;
    const fitRender = say => {
      if (!fitli || !SIZE) return;
      const T = F(); let fit = null; try { fit = T ? T.get() : null; } catch (e) { fit = null; }
      const has = !!(fit && fit.w && fit.r);
      let lab = has ? T.label(fit) : '';
      if (has && (fit.a === '' || fit.a == null)) lab += ', any profile';
      if (has && lab && T.same(fit, mine)) {
        fitli.hidden = false; fitx.hidden = true;
        fitli.innerHTML = `<span class="pf fit" tabindex="-1">${ic('circle-check')}Matches your ${esc(lab)} search</span>`;
      } else if (has && lab) {
        fitli.hidden = true; fitx.hidden = false;
        const url = fit.url && /^\/(?!\/)/.test(fit.url) ? fit.url : X.sizeUrl(fit.w, fit.a, fit.r);
        fitx.innerHTML = `${ic('circle-alert')}<p>You searched <b>${esc(lab)}</b>. This tyre is <b>${esc(SIZE)}</b>.</p><a class="lnk on-n" href="${esc(url)}">See ${esc(T.label(fit))} tyres${ic('arrow-right', 'i-go')}</a>`;
        if (lastFit !== lab) track('fit_mismatch_shown', { searched: lab, product: SIZE });
      } else {
        fitli.hidden = false; fitx.hidden = true;
        if (!$('#fxo', fitli)) fitli.innerHTML = fxoHTML;
      }
      lastFit = lab;
      barCheck();
      if (say) $('#fitlive').textContent = !has ? '' : T.same(fit, mine) ? `Matches your ${lab} search` : `You searched ${lab}. This tyre is ${SIZE}.`;
    };
    const fxe = $('#fxe');
    const clearErr = () => { if (fxe) fxe.hidden = true; $$('#fxs .fld.err').forEach(f => f.classList.remove('err')); };
    const openFx = (on, focus) => {
      if (!fxp) return;
      fxp.hidden = !on; const b = $('#fxo'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on && focus) setTimeout(() => { const s = $('#fxs:not([hidden]) select') || $('#fxr:not([hidden]) input'); if (s) s.focus(); }, 30);
      if (!on) clearErr();
      barCheck();
    };
    if (fxp) {
      fxp.addEventListener('change', e => { const s = e.target.closest('select'); if (!s) return; s.classList.toggle('empty', !s.value); if (s.value) { s.closest('.fld').classList.remove('err'); if (!$$('#fxs .fld.err').length && fxe) fxe.hidden = true; } });
      fxp.addEventListener('click', e => {
        const t = e.target.closest('[data-fxtab]'); if (!t) return;
        $$('[data-fxtab]', fxp).forEach(b => { const on = b === t; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        $('#fxs').hidden = t.dataset.fxtab !== 'size'; $('#fxr').hidden = t.dataset.fxtab !== 'reg'; clearErr();
      });
      $('#fxs').addEventListener('submit', e => {
        e.preventDefault();
        const sel = ['#fxw', '#fxa', '#fxrr'].map(s => $(s)), miss = sel.filter(s => !s.value);
        sel.forEach(s => s.closest('.fld').classList.toggle('err', !s.value));
        if (miss.length) { if (fxe) fxe.hidden = false; miss[0].focus(); return; }
        const [w, a, r] = sel.map(s => s.value);
        const T = F();
        openFx(false);
        if (T && T.set) { try { T.set({ w, a, r, url: X.sizeUrl(w, a, r) }); } catch (er) { /* stays as it was */ } }
        fitRender(true);
        const tgt = !fitx.hidden ? fitx : $('#fitli .pf'); if (tgt) tgt.focus();
      });
      $('#fxr').addEventListener('submit', e => { e.preventDefault(); location.href = ((window.routes && routes.root_url) || '/').replace(/\/?$/, '/') + '#reg'; });
    }
    document.addEventListener('click', e => {
      if (e.target.closest('#fxo')) openFx(fxp && fxp.hidden, true);
      else if (e.target.closest('#fxx')) { openFx(false); const b = $('#fxo'); if (b) b.focus(); }
    });
    document.addEventListener('td:fit-change', () => fitRender(false));
    fitRender(false);

    /* ================= Buy card: quantity, subtotal, Add (PM3 low stock: presets above stock are dimmed) ================= */
    const form = $('#pdp-form');
    const bq = $('#bq'), sbq = $('#sbq');
    let qn = +D.n0 || 1;
    const setN = n => {
      qn = n;
      $$('.pre [data-qn]', root).forEach(b => b.setAttribute('aria-pressed', +b.dataset.qn === n && b.getAttribute('aria-disabled') !== 'true' ? 'true' : 'false'));
      const t = X.priceHTML(PRICE * n / 100), x = `${n} x ${pounds(PRICE)}`;
      const put = (s, h, txt) => { const el = $(s, root); if (el) { if (txt) el.textContent = h; else el.innerHTML = h; } };
      put('#subt', t); put('#subx', x, 1); put('#sbt', t); put('#sbx', x, 1);
      put('#addl', `Add ${n} to basket`, 1); put('#adds', pounds(PRICE * n), 1); put('#sbn', String(n), 1);
      [bq, sbq].forEach(q => { if (q && +$('output', q).textContent !== n) X.setQty(q, n); });
      const inp = form && $('input[name="quantity"]', form); if (inp) inp.value = n;
    };
    if (BUY) {
      setN(qn);
      document.addEventListener('qty', e => { if (e.target === bq || e.target === sbq) setN(e.detail); });
      root.addEventListener('click', e => {
        const b = e.target.closest('.pre [data-qn]'); if (!b || !bq) return;
        if (b.getAttribute('aria-disabled') === 'true') return;
        X.setQty(bq, +b.dataset.qn); track('qty_select', { qty: +b.dataset.qn });
      });
      const add = btn => {
        if (!window.TDB || !btn) return false;
        if (btn.classList.contains('is-busy')) return true;
        track('add_to_basket', { qty: qn, source: btn.id === 'sbadd' ? 'buybar' : 'main', product_id: D.handle, variant_id: D.variant, unit_price: PRICE / 100 });
        window.TDB.add(D.variant, qn, btn);
        return true;
      };
      if (form) form.addEventListener('submit', e => { if (add($('#addb'))) e.preventDefault(); });
      const sb = $('#sbadd');
      if (sb) sb.addEventListener('click', e => { if (!add(e.currentTarget) && form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); } });
    }
    /* Out of stock rows: Add 1 of that tyre (their own attribute, so the shared price view never changes the 1) */
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-alt-add]'); if (!b) return;
      e.preventDefault();
      if (window.TDB && !b.classList.contains('is-busy')) { track('add_to_basket', { qty: 1, source: 'alternative', variant_id: b.dataset.altAdd }); window.TDB.add(b.dataset.altAdd, 1, b); }
    });

    /* ================= Read more (PM6) ================= */
    const desc = $('#ab-desc'), rd = $('#rd');
    if (desc && rd) {
      if (desc.scrollHeight > desc.clientHeight + 2) rd.hidden = false;
      rd.addEventListener('click', () => { const o = rd.getAttribute('aria-expanded') !== 'true'; rd.setAttribute('aria-expanded', o ? 'true' : 'false'); desc.classList.toggle('clamp', !o); rd.firstChild.textContent = o ? 'Read less' : 'Read more'; });
    }

    /* ================= EU label: the real EPREL image, or the designed "not published yet" state (R5) ================= */
    const REG = D.reg;
    const noLabel = () => {
      if (root.classList.contains('is-nolbl')) return;
      root.classList.add('is-nolbl');
      $$('[data-lbl="yes"]', root).forEach(el => { el.hidden = true; });
      $$('[data-lbl="no"]', root).forEach(el => { el.hidden = false; });
      const h = $('.eu-head h2[data-lbl="yes"]', root), h2 = $('.eu-head h2[data-lbl="no"]', root);
      if (h && h2) { h.removeAttribute('id'); h2.id = 'eu-h'; }
      $$('[data-eu]', root).forEach(el => { try { const d = JSON.parse(el.dataset.eu); if (d.r && d.r === REG) { d.r = ''; el.dataset.eu = JSON.stringify(d); } } catch (e) { /* not ours */ } });
      $$('[aria-label*="Opens the EU tyre label"]', root).forEach(el => el.setAttribute('aria-label', el.getAttribute('aria-label').replace('Opens the EU tyre label', 'Opens the EU label details')));
    };
    if (REG) {
      const li = $('[data-lbl-img]', root);
      if (li) { li.addEventListener('error', noLabel); if (li.complete && li.currentSrc && !li.naturalWidth) noLabel(); }
      later(() => { const p = new Image(); p.onerror = noLabel; p.onload = () => { if (!p.naturalWidth) noLabel(); }; p.src = `https://eprel.ec.europa.eu/labels/tyres/Label_${REG}.png`; }, 2500);
    }

    /* ================= Same size: in-stock summary and "Also in <size>" (sections/tdx-alt) ================= */
    const instockBase = () => { const s = $('[data-instock-link]', root); return s ? s.getAttribute('href') : ''; };
    const altUrl = params => {
      const base = instockBase(); if (!base) return '';
      const u = new URL(base, location.origin);
      Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
      u.searchParams.set('section_id', 'tdx-alt');
      return u.pathname + u.search;
    };
    const getAlt = params => {
      const url = altUrl(params); if (!url) return Promise.resolve(null);
      return fetch(url, { credentials: 'same-origin' }).then(r => (r.ok ? r.text() : '')).then(h => { if (!h) return null; const t = document.createElement('div'); t.innerHTML = h; return t; }).catch(() => null);
    };
    const sumOf = box => { try { return JSON.parse($('[data-alt-sum]', box).textContent); } catch (e) { return null; } };
    const plural = (n, one, many) => (n === 1 ? one : many);
    const paintSummary = S => {
      if (!S || !S.n) return;
      $$('[data-seeall]', root).forEach(el => { el.textContent = `See all ${S.n}`; });
      const oosl = $('#oosl');
      if (oosl && S.nb && S.min) {
        oosl.innerHTML = `<b>${S.n} ${plural(S.n, 'tyre', 'tyres')} in ${esc(SIZE)}</b> ${plural(S.n, 'is', 'are')} in stock now, from ${S.nb} ${plural(S.nb, 'brand', 'brands')}, from ${pounds(Math.round(S.min * 100))} a tyre.`;
        oosl.hidden = false;
      }
      const K = { fuel: S.fuel || {}, wet: S.wet || {}, noise: S.noise || {} };
      $$('.ctx[data-ctx]', root).forEach(p => {
        const n = K[p.dataset.ctx][p.dataset.c]; if (!n) return;
        p.innerHTML = `<b>${n} of the ${S.n}</b> ${plural(S.n, 'tyre', 'tyres')} we have in stock in ${esc(SIZE)} ${plural(n, 'is', 'are')} ${esc(p.dataset.what)}.`;
        p.hidden = false;
      });
      const bn = $('#brnum');
      if (bn && D.brand) {
        const key = Object.keys(S.brands || {}).find(k => k.toLowerCase() === D.brand.toLowerCase());
        const n = key ? S.brands[key] : 0;
        if (n) { bn.innerHTML = `<span class="big">${n}</span><span>${esc(D.brand)} ${plural(n, 'tyre', 'tyres')} in stock in ${esc(SIZE)}</span>`; bn.hidden = false; }
      }
    };
    /* Candidates: other brands, in stock; same tier, then same season first, then nearest in price (mockup pickAlts) */
    const pick = boxes => {
      const seen = new Set([D.handle]); const out = [];
      boxes.forEach(b => b && $$('[data-cand]', b).forEach(c => {
        const h = c.dataset.ch; if (seen.has(h)) return; seen.add(h);
        if (c.dataset.cbuy !== '1') return;
        if ((c.dataset.cb || '').toLowerCase() === (D.brand || '').toLowerCase()) return;
        out.push(c);
      }));
      const score = c => (c.dataset.ct === D.tier ? 0 : 1000) + (c.dataset.cs === D.season ? 0 : 500) + Math.abs(+c.dataset.cp - PRICE) / 100;
      /* a brand already picked counts against a tyre (after tier and season), so the four are usually four makers */
      const left = out.slice(), chosen = [], brands = new Set();
      while (chosen.length < 4 && left.length) {
        let bi = 0, bs = Infinity;
        left.forEach((c, i) => { const v = score(c) + (brands.has((c.dataset.cb || '').toLowerCase()) ? 300 : 0); if (v < bs) { bs = v; bi = i; } });
        const c = left.splice(bi, 1)[0]; brands.add((c.dataset.cb || '').toLowerCase()); chosen.push(c);
      }
      return chosen.sort((p, q) => +p.dataset.cp - +q.dataset.cp);
    };
    const logoFit = (img, area, maxW, maxH) => {
      const w0 = +img.getAttribute('width') || 4, h0 = +img.getAttribute('height') || 1, ar = w0 / h0;
      let w = Math.sqrt(area * ar), h = w / ar; if (w > maxW) { w = maxW; h = w / ar; } if (h > maxH) { h = maxH; w = h * ar; }
      return `<img src="${esc(img.getAttribute('src'))}" alt="${esc(img.getAttribute('alt'))}" width="${Math.round(w)}" height="${Math.round(h)}" style="width:${w.toFixed(1)}px;height:${h.toFixed(1)}px;object-fit:contain" loading="lazy">`;
    };
    const rowOf = c => {
      const card = $('.pc', c); if (!card) return '';
      const ph = $('.stg img.ph', card), lg = $('.lg img', card), nm = $('.nm a', card), eus = $('.eus', card), pr = $('.ft .pr', card), st = $('.stock', card), ad = $('[data-add]', card), ls = $('.sz b', card), sea = $('.sz .chip', card);
      let eu = {}; try { eu = JSON.parse(eus.dataset.eu); } catch (e) { eu = {}; }
      const price = pr ? +pr.dataset.p : +c.dataset.cp / 100;
      return `<li class="ai">
        <span class="ph">${ph ? `<img src="${esc(ph.getAttribute('src'))}" alt="" width="68" height="68" loading="lazy">` : ''}</span>
        <div class="id">
          <span class="lg">${lg ? logoFit(lg, 2400, 104, 24) : ''}</span>
          <h3 class="pat nm"><a href="${esc(nm ? nm.getAttribute('href') : '#')}"><span class="bar-t">${esc(nm ? nm.textContent.trim() : '')}</span></a></h3>
          <p class="sp"><span><b>${esc(ls ? ls.textContent.trim() : '')}</b> ${esc(sea ? sea.textContent.trim() : '')}</span>${eus ? `<button class="aeu" type="button" data-eu="${esc(eus.dataset.eu)}" aria-haspopup="dialog">${X.eua('fuel', eu.f, 'sm')}${X.eua('wet', eu.w, 'sm')}${X.noise(eu.db, eu.n)}<span class="sr">Open the EU tyre label for ${esc(eu.t)}</span></button>` : ''}</p>
        </div>
        <div class="pw"><span class="pr">${X.priceHTML(price)}</span>${st ? st.outerHTML : ''}</div>
        ${ad ? `<button class="btn sk" type="button" data-td-chat-clear data-alt-add="${esc(ad.dataset.add)}"><span>Add 1<span class="sr"> ${esc(eu.t)}</span></span>${ic('arrow-right', 'i-go')}</button>` : ''}
      </li>`;
    };
    const paintAlts = chosen => {
      if (!chosen.length) return;
      if (!BUY) {
        const box = $('#altin'), list = $('#ail'); if (!box || !list) return;
        list.innerHTML = chosen.map(rowOf).join(''); box.hidden = false;
        return;
      }
      const sec = $('#alt-sec'), grid = $('#alts'); if (!sec || !grid) return;
      grid.innerHTML = ''; chosen.forEach(c => { const card = $('.pc', c); if (card) grid.appendChild(card); });
      if (chosen.every(c => c.dataset.ct === D.tier)) sec.classList.add('same-tier');
      $('#adots').innerHTML = chosen.map((_, i) => `<i${i ? '' : ' class="on"'}></i>`).join('');
      grid.addEventListener('scroll', () => { const f = grid.firstElementChild; if (!f) return; const w = f.getBoundingClientRect().width + 12, i = Math.round(grid.scrollLeft / w); $$('#adots i').forEach((d, k) => d.classList.toggle('on', k === i)); }, { passive: true });
      sec.hidden = false;
      X.renderPrices(grid); X.renderCd(grid);
    };
    const loadSame = () => {
      if (!instockBase() || !D.w || !D.r) return;
      const p = PRICE / 100;
      const sumP = getAlt({ sort_by: 'price-ascending' }).then(b => { paintSummary(b && sumOf(b)); });
      const wins = p > 0
        ? [getAlt({ 'filter.v.price.gte': (p * 0.75).toFixed(2), 'filter.v.price.lte': p.toFixed(2), sort_by: 'price-descending' }),
           getAlt({ 'filter.v.price.gte': p.toFixed(2), 'filter.v.price.lte': (p * 1.4).toFixed(2), sort_by: 'price-ascending' })]
        : [getAlt({ 'filter.v.price.gte': '0.01', sort_by: 'price-ascending' })];
      Promise.all(wins).then(boxes => paintAlts(pick(boxes))).catch(() => { /* the section stays hidden */ });
      return sumP;
    };
    if (BUY) later(loadSame, 2000); else loadSame();

    /* ================= Sticky bar (P2, P13, PM3) ================= */
    /* Phones: from load until the card's Add is fully on screen, and again once it has scrolled away; wider screens:
       before the buy card comes into view and after its Add has gone. Out of stock: once the rows under the card (or
       the card) have scrolled away. Never over the footer. */
    const bar = $('#sbar');
    if (bar) {
      const buy = $('#buy'), addb = $('#addb'), altin = $('#altin'), ftr = document.querySelector('.ftr'), phone = matchMedia('(max-width:760px)');
      if (window.TD && TD.observeBuybar) TD.observeBuybar(bar);
      let raf = 0;
      const chk = () => {
        raf = 0; const H = innerHeight;
        const over = ftr && ftr.getBoundingClientRect().top < H;
        let want = false;
        if (!BUY) { const el = altin && !altin.hidden ? altin : buy; want = !!el && el.getBoundingClientRect().bottom < 0; }
        else if (addb && buy) { const a = addb.getBoundingClientRect(), b = buy.getBoundingClientRect(); want = phone.matches ? (a.top < 0 || a.bottom > H) : (a.bottom < 0 || b.top > H - 60); }
        const show = want && !over;
        if (bar.hidden === show) { bar.hidden = !show; if (window.TD && TD.checkChatClearance) TD.checkChatClearance(); }
      };
      const q = () => { if (!raf) raf = requestAnimationFrame(chk); };
      barCheck = q;
      addEventListener('scroll', q, { passive: true }); addEventListener('resize', q); chk();
      document.addEventListener('cart-drawer:close', q);
    }

    /* ================= Deep links: #viewer, #viewer-2 (a photo), #fit-check (the size entry open) ================= */
    const applyHash = first => {
      if (location.hash === '#fit-check' && fxp && !$('.pf.fit', fitli || document) && (!fitx || fitx.hidden)) openFx(true, !first);
      const m = location.hash.match(/^#viewer(?:-(\d+))?$/);
      if (V && m) setTimeout(() => V.open(Math.max(0, Math.min(N - 1, (+m[1] || 1) - 1))), first ? 150 : 0);
    };
    applyHash(true);
    addEventListener('hashchange', () => applyHash(false));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
